module.exports = __webpack_public_path__ + "static/iphone-a997886898a9438a308f6aee96bba233.png";